var _ellipse, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 16,
    cy: 23.9998,
    rx: 1.33333,
    ry: 1.33333,
    fill: "#181C21"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3334 7.33317C13.3334 6.96498 13.6319 6.6665 14 6.6665H18C18.3682 6.6665 18.6667 6.96498 18.6667 7.33317C18.6667 7.70136 18.3682 7.99984 18 7.99984H14C13.6319 7.99984 13.3334 7.70136 13.3334 7.33317Z",
    fill: "#181C21"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.33329 2.6665C7.86053 2.6665 6.66663 3.86041 6.66663 5.33317V24.7899C6.91594 24.9482 7.22688 25.0646 7.59912 25.1501C8.1328 25.2725 8.72662 25.3146 9.33329 25.3283V5.33317L22.6666 5.33317V26.6665H10.6354C10.539 26.6666 10.4394 26.667 10.337 26.6674L10.3359 26.6674C10.0976 26.6684 9.84438 26.6695 9.58281 26.6665H9.33329V26.6624C8.66155 26.6474 7.94936 26.5984 7.30086 26.4496C7.08741 26.4006 6.87431 26.3391 6.66663 26.2622V26.6665C6.66663 28.1393 7.86053 29.3332 9.33329 29.3332H22.6666C24.1394 29.3332 25.3333 28.1393 25.3333 26.6665V5.33317C25.3333 3.86041 24.1394 2.6665 22.6666 2.6665H9.33329Z",
    fill: "#181C21"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPhone);
export default __webpack_public_path__ + "static/media/icon_phone.3ff9bef1fc400f2971b9dec1b0f1e617.svg";
export { ForwardRef as ReactComponent };